// extracted by mini-css-extract-plugin
export default {"column":"PostReorderColumn_column__PWOhk","button":"PostReorderColumn_button__oT-o6","number":"PostReorderColumn_number__Jnlp5","spinner":"PostReorderColumn_spinner__NE6rO"};